import { SCREEN_RESIZE } from "constants/actionTypes";
import { ScreenType } from "constants/screen";
import { breakpoints } from "constants/theme";

const initialWidth = typeof window === "object" ? window.innerWidth : null;

const initialState = {
  width: initialWidth,
  type: initialWidth > breakpoints[2] ? ScreenType.DESKTOP : ScreenType.MOBILE,
};

export default function uiReducer(state = initialState, action) {
  switch (action.type) {
    case SCREEN_RESIZE:
      return {
        ...state,
        width: action.width,
        type:
          action.width >= breakpoints[2]
            ? ScreenType.DESKTOP
            : ScreenType.MOBILE,
      };
    default:
      return state;
  }
}
